import React, {Component} from 'react';
import {Field} from 'redux-form'

// import VirtualizedSelect from 'react-virtualized-select'
// import Select,{Creatable} from 'react-select'
import Select from 'react-select'
import Creatable from 'react-select/creatable';

// import 'react-select/dist/react-select.css';
// import 'react-virtualized/styles.css'
// import 'react-virtualized-select/styles.css'

import {locale} from '../locale/AppLocale';
import Editor from './Editor';
import DropZone from '../Components/DropZone';
import {GetEntityAttribute} from "../Helpers/Entity";


const renderPlainField = ({input, placeholder, type, disabled, meta: {touched, error}}) => (
    <div className={`form-group input-c input-c--plain ` + (touched && error ? `has-error` : ``)}>
        <input {...input} disabled={disabled} placeholder={placeholder} className="input" type={type}/>
        {touched
            && ((error && <span className="help-block is-error">{error}</span>))}
    </div>
);

export default class ProductInput extends Component {

    render() {

        let input = null;

        if (this.props.field.data_type === 'dropdown') {
            input = <CustomField {...this.props} />;
        } else if (this.props.field.data_type === 'bool') {
            input = <Boolean {...this.props} />;
        } else if (this.props.field.data_type === 'dropzone' || this.props.type === 'dropzone') {
            input = <DropZone disabled={this.props.disabled} inputProps={this.props} name={this.props.input.name}/>;
        } else if (this.props.field.data_type === 'textarea' || this.props.type === 'textarea') {
            input = <Editor value={this.props.input.value} disabled={this.props.disabled} id={this.props.id}
                            onChange={this.props.input.onChange}/>
        } else {
            input = <input
                {...this.props.input}
                id={this.props.id}
                disabled={this.props.disabled}
                className={(this.props.type === 'checkbox' || this.props.type === 'radio') ? '' : 'input'}
                placeholder={this.props.placeholder}
                type={this.props.type}/>;
        }

        return (
            <div className={`input-c ` + (this.props.meta.touched && this.props.meta.error ? `has-error` : ``)}>
                {this.props.label && this.props.label.length > 0 ? (
                    <label htmlFor={this.props.id}
                           className={'label ' + (this.props.field.is_required ? ' label--required ' : '')}>
                        {this.props.label} {this.props.field.is_variant ? 'is Variant' : ''}
                    </label>
                ) : ('')}

                <div className={`input-type-wrapper input-type-` + this.props.type}>
                    {this.props.alt_label && <label className="alt-label label">
                        {input}
                        {this.props.alt_label}
                    </label>}
                    {!this.props.alt_label && input}
                    {this.props.meta.touched
                        && ((this.props.meta.error &&
                                <span className="help-block is-error">{this.props.meta.error}</span>)
                            || (this.props.meta.warning && <span>{this.props.meta.warning}</span>))}
                </div>
                <div className="clearfix"></div>
            </div>
        )
    }
}

class CustomField extends Component {

    render() {
        if (this.props.field && this.props.field.data_type !== 'dropdown') {
            return null;
        }
        const inputProps = this.props.input;
        const options = this.formatSelectOptions();
        const isVariant = this.props.field.is_variant === true;

        // Variant fields keep an array of the full option objects (needed by
        // getValues()/ValidateProduct.js), non-variant fields keep a plain scalar
        // (the option's `value`), so we translate to/from the Select's expected
        // option-object shape here.
        let selectValue;
        if (isVariant) {
            selectValue = Array.isArray(inputProps.value) ? inputProps.value : [];
        } else {
            let scalarValue = inputProps.value;
            if (scalarValue && typeof scalarValue === 'object') {
                scalarValue = scalarValue.value;
            }
            selectValue = options.find((option) => option.value === scalarValue) || null;
        }

        if (isVariant) {
            return (
                <div>
                    <Creatable
                        {...inputProps}
                        id={this.props.id}
                        options={options}
                        value={selectValue}
                        onBlur={undefined}
                        isMulti={true}
                        closeMenuOnSelect={false}
                        isDisabled={this.props.disabled}
                        onChange={this.onSelectChange.bind(this)}
                        formatCreateLabel={(label) => locale.get('add_option') + ' ' + label}
                        getNewOptionData={(inputValue, optionLabel) => ({
                            id: inputValue,
                            name: inputValue,
                            field: this.props.field.name,
                            group_id: this.props.field.group_id,
                            attribute_id: this.props.field.id,
                            label: optionLabel,
                            value: inputValue,
                        })}
                        placeholder={locale.get('choose')}/>
                </div>
            )
        } else {
            return (
                <div>
                    <Select
                        {...inputProps}
                        value={selectValue}
                        id={this.props.id}
                        options={options}
                        onBlur={undefined}
                        isMulti={false}
                        isDisabled={this.props.disabled}
                        onChange={this.onSelectChange.bind(this)}
                        placeholder={locale.get('choose')}/>

                    {this.props.field.has_other === true
                        && inputProps.value === -1
                        &&
                        <Field
                            type="text"
                            component={renderPlainField}
                            name={this.props.field.name + `_other`}
                            className="input"
                            placeholder={locale.get('specify_your_own')}/>}
                </div>
            )
        }

    }


    formatSelectOptions() {

        if (this.props.field.selectOptions) {
            return this.props.field.selectOptions || [];
        } else {

            const final = [];
            let groupId = this.props.field.group_id;
            let attributeId = this.props.field.id;

            this.props.field.options.forEach((item) => {
                final.push({
                    value: item.id,
                    label: GetEntityAttribute(item,'title'),
                    group_id: groupId,
                    attribute_id: attributeId,
                    field: this.props.field.name
                })
                //@TODO after Ramadan ,,, this called a lot ... literally a lot
                // console.log(item.id,this.props.field.name)
            });

            if (this.props.field.is_variant === false && this.props.field.has_other === true) {
                final.push({
                    value: -1,
                    label: locale.get('specify_your_own'),
                    field: this.props.field.name,
                    group_id: groupId,
                    attribute_id: attributeId,
                })
            }
            return final;
        }
    };

    onSelectChange(value) {
        if (this.props.field.is_variant === true) {
            // Multi-select: keep the full array of option objects, as expected by
            // getValues() (Product.js) which maps over `.value` for each item.
            this.props.input.onChange(Array.isArray(value) ? value : (value ? [value] : []));
        } else {
            // Single-select: store the plain scalar value, matching what
            // getValues()/ValidateProduct.js expect for non-variant dropdown fields.
            this.props.input.onChange(value ? value.value : null);
        }
    }


    shouldComponentUpdate(nextProps, nextState) {
        if (
            (!nextProps.input.value && !this.props.input.value)
            || nextProps.input.value === this.props.input.value
        ) {
            return false;
        }
        return true;
    }

}

class Boolean extends React.Component {


    render() {
        return (
            <div>
                <Radio {...this.props} label={locale.get('yes')} value={1}/>
                <Radio {...this.props} label={locale.get('no')} value={0}/>
            </div>
        )
    }

}

class Radio extends React.Component {
    render() {
        let savedValue = parseInt(this.props.input.value, 10) ? 1 : 0;
        return (
            <label className="control control--radio">
                <input
                    {...this.props.input}
                    id={this.props.id}
                    disabled={this.props.disabled}
                    className='radio'
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    defaultChecked={this.props.value === savedValue}
                    type="radio"/>
                <div className="control__indicator"></div>
                {this.props.label}
            </label>
        )
    }
}